// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@west/App/SharedStyles/CartLineSharedStyles";
import { requisitionsProductListLineStyles } from "@west/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import { css } from "styled-components";

requisitionsProductListLineStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 128px minmax(0, 1fr) minmax(0, 170px) minmax(0, 120px) minmax(0, 170px) minmax(
                    0,
                    12px
                );
        `,
    },
    notes: {
        css: css`
            overflow: auto;
        `,
    },
};

requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};
requisitionsProductListLineStyles.productImageStyles = {
    ...cartLineSharedStyles.productImage,
};
requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};
requisitionsProductListLineStyles.subtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};
requisitionsProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    mergeCss: true,
    css: css`
        margin-top: 10px;
    `,
};

requisitionsProductListLineStyles.qtyOrderedField = {
    ...cartLineSharedStyles.qtyInputStyle,
};
